"use client";
import React, {
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { Flex, Text } from "@radix-ui/themes";
import { cn } from "@/lib/utils";
import { Playfair_Display, PT_Mono } from "next/font/google";
import useWindowSize from "../hooks/useWindowSize";

const HEADER = `${process.env.NEXT_PUBLIC_TENANT_NAME} Auctions PRESENTS`;
const PTMono = PT_Mono({ subsets: ["latin"], weight: ["400"] });
const PlayfairDisplay = Playfair_Display({ subsets: ["latin"] });


const BuyerHomeHeader = ({
  title,
  header = true,
}: {
  title: string;
  header?: boolean;
}) => {
  const titleRef = useRef<HTMLElement>(null);
  const [displayUnderline, setDisplayUnderline] = useState(false);
  const { width } = useWindowSize();
  useLayoutEffect(() => {
    const calculateLineCount = () => {
      if (titleRef.current) {
        const scrollHeight = titleRef.current.scrollHeight;
        const lineHeight = parseInt(
          window.getComputedStyle(titleRef.current).lineHeight
        );
        const lineCount = Math.floor(scrollHeight / lineHeight);
        setDisplayUnderline(lineCount === 1);
      }
    };

    calculateLineCount();
  }, [width]);
  return (
    <Flex direction={"column"} align={"center"} className={cn("mb-8")}>
      {header && (
        <Text className={cn("text-2xl text-center", PTMono.className, "text-wrap")}>
          {HEADER.toLocaleUpperCase()}
        </Text>
      )}
      <Flex className={cn("relative px-2")} justify={"center"}>
        <Text
          className={cn(
            "text-5xl font-extrabold z-20 ",
            PlayfairDisplay.className,
            !displayUnderline && "text-center"
          )}
          ref={titleRef}
        >
          {title}
        </Text>
        {displayUnderline && (
          <Flex
            position={"absolute"}
            className="bg-gradient-to-br from-biddify/30 to-[#9e8f77]/35 w-full h-1/2 z-10 translate-y-9"
          />
        )}
      </Flex>
    </Flex>
  );
};

export default BuyerHomeHeader;
